export const REGISTRATION_TITLE = 'app.registration.form.title'
export const REGISTRATION_EVENT_GROUP = 'Registration'
